import liff from '@line/liff'
export default {
    async getLineIdForLiff (liffId) {
        await liff.init({ liffId }).catch(err => { throw err })
        const profile = await liff.getProfile()
        return profile.userId
    },

    async scanCodeV2 (liffId) {
        await liff.init({ liffId }).catch(err => { throw err })
        let value = null
        try {
            const result = await liff.scanCodeV2()
            value = result.value
        } catch (error) {
            await liff.closeWindow()
        }

        return value
    },

    async closeWindow (liffId) {
        await liff.init({ liffId }).catch(err => { throw err })
        await liff.closeWindow()
    },

    getLineOs () {
        return liff.getOS()
    }
}
